const resolutions = {
  screenXs: 480,
  screenXsMin: 480,

  // Small screen / tablet
  screenSm: 576,
  screenMd: 768,
  screenLg: 992,
  screenXl: 1200,
  screenXxl: 1600,
};
export const BREAK_POINTS = {
  ...resolutions,
  screenSmMin: resolutions.screenSm,

  // Medium screen / desktop
  screenMdMin: resolutions.screenMd,

  // Large screen / wide desktop
  screenLgMin: resolutions.screenLg,

  // Extra large screen / full hd
  screenXlMin: resolutions.screenXl,

  // Extra extra large screen / large desktop
  screenXxlMin: resolutions.screenXxl,

  // provide a maximum
  screenXsMax: resolutions.screenSm - 1,
  screenSmMax: resolutions.screenMd - 1,
  screenMdMax: resolutions.screenLg - 1,
  screenLgMax: resolutions.screenXl - 1,
  screenXlMax: resolutions.screenXxl - 1,
};

export const CHILD_CARE_TYPES = [
  { name: 'Full-time', value: 'Full-time' },
  { name: 'Part-time', value: 'Part-time' },
  { name: 'Before Care', value: 'Before Care' },
  { name: 'After Care', value: 'After Care' },
  { name: 'Respite', value: 'Respite' },
];

export const AUTH_STATES = {
  SIGN_IN: 'signIn',
  CONFIRM_SIGN_IN: 'confirmSignIn',
  SIGN_UP: 'signup',
  CONFIRM_SIGN_UP: 'confirmSignUp',
  LOGGED_IN: 'signedIn',
  TOTP_SETUP: 'TOTPSetup',
  REQUIRE_NEW_PASSWORD: 'requireNewPassword',
  FORGOT_PASSWORD: 'forgotPassword',
  RESET_PASSWORD: 'resetPassword',
  CHANGE_PASSWORD: 'changePassword',
  PROVIDER_ACTIVATE: 'providerActivate',
};

export const RESET_ALL = 'reset-all';

export const PROVIDER_STATUSES = {
  INCOMPLETE: 'INCOMPLETE',
  SUBMITTED: 'SUBMITTED',
  REVIEWED: 'REVIEWED',
  PENDING: 'PENDING',
  VERIFYING: 'VERIFYING',
  DOC_REVIEW_REQUIRED: 'DOC_REVIEW_REQUIRED',
  DOC_REVIEW: 'DOC_REVIEW',
  MANAGER_DOC_REVIEW: 'MANAGER_DOC_REVIEW',
  READY_FOR_QC: 'READY_FOR_QC',
  QC_REVIEW: 'QC_REVIEW',
  QC_MANAGER_REVIEW: 'QC_MANAGER_REVIEW',
  QC_REJECTED: 'QC_REJECTED',
  APPROVED: 'APPROVED',
  DEACTIVATED: 'DEACTIVATED',
  DISQUALIFIED: 'DISQUALIFIED',
  QC_EXCEPTION: 'QC_EXCEPTION',
};
export const FAMILY_STATUSES = {
  INCOMPLETE: 'INCOMPLETE',
  PENDING: 'PENDING',
  VERIFYING: 'VERIFYING',
  ENHANCED_REFERRAL_REQUIRED: 'ENHANCED_REFERRAL_REQUIRED',
  ENHANCED_REFERRAL_ASSIGNED: 'ENHANCED_REFERRAL_ASSIGNED',
  ENHANCED_REFERRAL_COMPLETE: 'ENHANCED_REFERRAL_COMPLETE',
  PENDING_PROVIDER_COMPLETION: 'PENDING_PROVIDER_COMPLETION',
  QC_REQUIRED: 'QC_REQUIRED',
  QC_ASSIGNED: 'QC_ASSIGNED',
  QC_REJECTED: 'QC_REJECTED',
  QC_REVIEW: 'QC_REVIEW',
  ENROLLED: 'ENROLLED',
  APPROVED: 'APPROVED',
  QC_EXCEPTION: 'QC_EXCEPTION',
  DEACTIVATED: 'DEACTIVATED',
  DISQUALIFIED: 'DISQUALIFIED',
  MANAGER_REVIEW: 'MANAGER_REVIEW',
};

export const ASSIGNMENT_TYPES = {
  CASE_OWNER: 'Case Owner',
  QC_REVIEW: 'QC Review',
  QC_MANAGER_REVIEW: 'QC Manager Review',
  BGC_REVIEW: 'BGC Review',
  BGC_MANAGER_REVIEW: 'BGC Manager Review',
  DOC_REVIEW: 'Doc Review',
  MANAGER_REVIEW: 'Manager Review',
  MANAGER_DOC_REVIEW: 'Manager Doc Review',
};

export const NAME_REGEX = /^[A-Za-z',.\-\s]+$/;
export const SINGLE_REGEX = /^[-'a-zA-Z]+$/;
export const BUSINESS_NAME_REGEX = /^(?!\s)(?=.*[a-zA-Z0-9])[-a-zA-Z0-9 ',.&]{2,}$/;
export const FACILITY_NAME_REGEX = /^(?!\s)(?=.*[a-zA-Z0-9]).*$/;
export const ZIP_CODE_REGEX = /^\d{5}(?:[-\s]\d{4})?$/;
export const PHONE_NUMBER_REGEX = /^\+1\d{10}|\(\d{3}\)\s\d{3}-\d{4}$/;
export const FORMATTED_PHONE_NUMBER_REGEX = /^\(\d{3}\)\s\d{3}-\d{4}$/;
export const SIMPLE_PHONE_NUMBER_REGEX = /^\+1\d{10}$/;
export const PHONE_NUMBER_EXT_REGEX = /^\d{1,5}$/;
export const PHONE_NUMBER_EXT_CHARLIMIT = 5;
export const PHONE_NUMBER_MASK = '(111) 111-1111';
export const PHONE_EXT_MASK = '11111';
export const TIME_PICKET_MASK = '11:11';
export const DATE_FORMAT = [
  'MMM DD, YYYY',
  'MM/DD/YYYY',
  'YYYY-MM-DD',
  // 'YYYY-M-DD',
  // 'YYYY-MM-D',
  // 'YYYY-M-D',
  // 'YY-M-D',
  // 'YY-MM-D',
  // 'YY-MM-DD',
  // 'YY-M-DD',
  // 'MMM D, YYYY',
  'MM/DD/YYYY',
  'MM/DD/YY',
  'M/DD/YYYY',
  'M/DD/YY',
  'MM/D/YYYY',
  'MM/D/YY',
  'M/D/YYYY',
  'M/D/YY',
];
export const BACKEND_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const CLIENT_DATE_TIME_FORMAT = 'MM/DD/YYYY - hh:mm A';

export const USA_STATES = [
  {
    name: 'Alabama',
    abbreviation: 'AL',
  },
  {
    name: 'Alaska',
    abbreviation: 'AK',
  },
  {
    name: 'American Samoa',
    abbreviation: 'AS',
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
  },
  {
    name: 'California',
    abbreviation: 'CA',
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC',
  },
  {
    name: 'Federated States Of Micronesia',
    abbreviation: 'FM',
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
  },
  {
    name: 'Guam',
    abbreviation: 'GU',
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
  },
  {
    name: 'Marshall Islands',
    abbreviation: 'MH',
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
  },
  {
    name: 'New York',
    abbreviation: 'NY',
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
  },
  {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP',
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
  },
  {
    name: 'Palau',
    abbreviation: 'PW',
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR',
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
  },
  {
    name: 'Virgin Islands',
    abbreviation: 'VI',
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
  },
];

export const USA_STATES_DROPDOWN_OPTIONS = [
  {
    name: 'Alabama',
    code: 'AL',
  },
  {
    name: 'Alaska',
    code: 'AK',
  },
  {
    name: 'American Samoa',
    code: 'AS',
  },
  {
    name: 'Arizona',
    code: 'AZ',
  },
  {
    name: 'Arkansas',
    code: 'AR',
  },
  {
    name: 'California',
    code: 'CA',
  },
  {
    name: 'Colorado',
    code: 'CO',
  },
  {
    name: 'Connecticut',
    code: 'CT',
  },
  {
    name: 'Delaware',
    code: 'DE',
  },
  {
    name: 'District Of Columbia',
    code: 'DC',
  },
  {
    name: 'Florida',
    code: 'FL',
  },
  {
    name: 'Georgia',
    code: 'GA',
  },
  {
    name: 'Guam',
    code: 'GU',
  },
  {
    name: 'Hawaii',
    code: 'HI',
  },
  {
    name: 'Idaho',
    code: 'ID',
  },
  {
    name: 'Illinois',
    code: 'IL',
  },
  {
    name: 'Indiana',
    code: 'IN',
  },
  {
    name: 'Iowa',
    code: 'IA',
  },
  {
    name: 'Kansas',
    code: 'KS',
  },
  {
    name: 'Kentucky',
    code: 'KY',
  },
  {
    name: 'Louisiana',
    code: 'LA',
  },
  {
    name: 'Maine',
    code: 'ME',
  },
  {
    name: 'Maryland',
    code: 'MD',
  },
  {
    name: 'Massachusetts',
    code: 'MA',
  },
  {
    name: 'Michigan',
    code: 'MI',
  },
  {
    name: 'Minnesota',
    code: 'MN',
  },
  {
    name: 'Mississippi',
    code: 'MS',
  },
  {
    name: 'Missouri',
    code: 'MO',
  },
  {
    name: 'Montana',
    code: 'MT',
  },
  {
    name: 'Nebraska',
    code: 'NE',
  },
  {
    name: 'Nevada',
    code: 'NV',
  },
  {
    name: 'New Hampshire',
    code: 'NH',
  },
  {
    name: 'New Jersey',
    code: 'NJ',
  },
  {
    name: 'New Mexico',
    code: 'NM',
  },
  {
    name: 'New York',
    code: 'NY',
  },
  {
    name: 'North Carolina',
    code: 'NC',
  },
  {
    name: 'North Dakota',
    code: 'ND',
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
  },
  {
    name: 'Ohio',
    code: 'OH',
  },
  {
    name: 'Oklahoma',
    code: 'OK',
  },
  {
    name: 'Oregon',
    code: 'OR',
  },
  {
    name: 'Pennsylvania',
    code: 'PA',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
  },
  {
    name: 'Rhode Island',
    code: 'RI',
  },
  {
    name: 'South Carolina',
    code: 'SC',
  },
  {
    name: 'South Dakota',
    code: 'SD',
  },
  {
    name: 'Tennessee',
    code: 'TN',
  },
  {
    name: 'Texas',
    code: 'TX',
  },
  {
    name: 'Utah',
    code: 'UT',
  },
  {
    name: 'Vermont',
    code: 'VT',
  },
  {
    name: 'Virgin Islands',
    code: 'VI',
  },
  {
    name: 'Virginia',
    code: 'VA',
  },
  {
    name: 'Washington',
    code: 'WA',
  },
  {
    name: 'West Virginia',
    code: 'WV',
  },
  {
    name: 'Wisconsin',
    code: 'WI',
  },
  {
    name: 'Wyoming',
    code: 'WY',
  },
];

export const QRIS_STATES = [
  {
    id: 'MD',
    title: 'Maryland',
  },
  {
    id: 'VA',
    title: 'Virginia',
  },
  {
    id: 'CA',
    title: 'California',
  },
  {
    id: 'WA',
    title: 'Washington',
  },
  {
    id: 'FL',
    title: 'Florida',
  },
  {
    id: 'OK',
    title: 'Oklahoma',
  },
  {
    id: 'NC',
    title: 'North Carolina',
  },
  {
    id: 'NV',
    title: 'Nevada',
  },
];

export const selectCommonStyles = {
  control: (provided) => ({ ...provided, height: 30, minHeight: 30 }),
  valueContainer: (provided) => ({ ...provided, height: 30, marginTop: -5 }),
  input: (provided) => ({ ...provided, height: 30, margin: 0 }),
  indicatorsContainer: (provided) => ({ ...provided, height: 30 }),
};

export const militaryServiceTypes = [
  { label: 'Army', value: 'Army' },
  { label: 'Navy', value: 'Navy' },
  { label: 'Marine Corps', value: 'Marine Corps' },
  { label: 'Coast Guard', value: 'Coast Guard' },
  { label: 'Air Force', value: 'Air Force' },
];
export const serviceCategoryTypes = [
  { label: 'Army', value: 'Army' },
  { label: 'Navy', value: 'Navy' },
  { label: 'Marine Corps', value: 'Marine Corps' },
  { label: 'Coast Guard', value: 'Coast Guard' },
  { label: 'Air Force', value: 'Air Force' },
];

export const KEYS = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  SPACE: 32,
  PAGEUP: 33,
  PAGEDOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
};

export const TIME_FORMAT = {
  HOURS_MINUTES_SECONDS: 'HH:mm:ss',
  HOURS_MINUTES: 'HH:mm',
  HMS_SHORT_FORMAT: 'h:m:s',
  HOURS_MINUTES_AM_PM: 'hh:mm A',
};

export const AM_PM_TIME_FORMAT_REGEX = /^\d\d:\d\d (A|P)M$/;

export const ADD_FACILITY_STEPS = {
  GET_STARTED: 'get-started',
  BUSINESS_DETAILS: 'business-details',
  FACILITY_DETAILS: 'facility-details',
  FACILITY_TYPE: 'facilities',
  SCHOOL_CREDENTIALS: 'school-credentials',
  CREDENTIALS: 'credentials',
  DETAILS: 'details',
  DOCUMENTS: 'documents',
  DISCOUNTS: 'discounts',
  AGREEMENT: 'agreement',
  SUBMITTED: 'submitted',
  PROGRAM: 'program',
};
export const ADD_APPLICATION_STEPS = {
  FAMILY_INFORMATION: 'family-information',
  ACCREDITATION: 'accreditation',
  RATES: 'rates',
  DISCOUNTS: 'discounts',
  AGREEMENT: 'agreement',
  SUBMITTED: 'submitted',
};

export const ADD_APPLICATION_STEPS_MAPPING = Object.keys(ADD_APPLICATION_STEPS).reduce((mapping, step, index) => {
  mapping[ADD_APPLICATION_STEPS[step]] = index;
  return mapping;
}, {});

export const ADD_NAVY_HCC_STEPS = {
  PROGRAM_INFO: 'program-info',
  HOURS_OF_OPERATION: 'hours-of-operation',
  STAFF_MEMBERS: 'staff-members',
  RESIDENTS: 'residents',
  AGREEMENT: 'agreement',
};

export const ADD_AIR_FORCE_HCC_STEPS = {
  PROGRAM_INFO: 'program-info',
  CREDENTIALS: 'credentials',
  HOURS_OF_OPERATION: 'hours-of-operation',
  STAFF_MEMBERS: 'staff-members',
  RESIDENTS: 'residents',
  INSURANCE: 'insurance',
  AGREEMENT: 'agreement',
};

export const ADD_AIR_FORCE_HCC_STEPS_MAPPING = {
  [ADD_AIR_FORCE_HCC_STEPS.PROGRAM_INFO]: 0,
  [ADD_AIR_FORCE_HCC_STEPS.CREDENTIALS]: 1,
  [ADD_AIR_FORCE_HCC_STEPS.HOURS_OF_OPERATION]: 2,
  [ADD_AIR_FORCE_HCC_STEPS.STAFF_MEMBERS]: 3,
  [ADD_AIR_FORCE_HCC_STEPS.RESIDENTS]: 4,
  [ADD_AIR_FORCE_HCC_STEPS.INSURANCE]: 5,
  [ADD_AIR_FORCE_HCC_STEPS.AGREEMENT]: 6,
};

export const ADD_FAMILY_STEPS = {
  START: 'start',
  PROGRAMS: 'programs',
  ELIGIBILITY: 'eligibility',
  SPONSOR: 'sponsor',
  SECOND_PARENTS: 'secondParents',
  SECOND_PARENTS_DOCS: 'secondParentDocs',
  CHILDREN: 'children',
  CHILDREN_DOCUMENTS: 'childrenDocuments',
  AGREEMENT: 'agreement',
  SUBMITTED: 'submitted',
  PROVIDER_INFO: 'provider-info',
  INCOME_INFO: 'income-info',
  CERTIFICATES: 'certificates',
  RESERVATION: 'Reservation',
};
export const ADD_FAMILY_STEPS_ORDER = [
  ADD_FAMILY_STEPS.START,
  ADD_FAMILY_STEPS.PROGRAMS,
  ADD_FAMILY_STEPS.SPONSOR,
  ADD_FAMILY_STEPS.SECOND_PARENTS,
  ADD_FAMILY_STEPS.SECOND_PARENTS_DOCS,
  ADD_FAMILY_STEPS.CHILDREN,
  ADD_FAMILY_STEPS.CHILDREN_DOCUMENTS,
  ADD_FAMILY_STEPS.AGREEMENT,
  ADD_FAMILY_STEPS.SUBMITTED,
  ADD_FAMILY_STEPS.RESERVATION,
];
export const ADD_FAMILY_TABS = {
  FORMS: 'forms',
  DOCUMENTS: 'documents',
  INFO: 'info',
  EMPLOYMENT: 'employment',
  SCHOOL_SCHEDULE: 'schoolSchedule',
  ELIGIBILITY: 'eligibility',
  AGREEMENT: 'agreement',
};

export const CHANGE_REQUEST_BG = 'border-2 p-1 border-red-400 bg-red-400 bg-opacity-70';

export const FACILITY_DETAILS_TABS = {
  PROGRAM: 'program',
  BUSINESS_INFO: 'business-info',
  CONTACT_INFO: 'contact-info',
  CREDENTIALS: 'credentials',
  CENTER_DETAILS: 'center-details',
  DISCOUNTS_INFO: 'discounts-info',
  SCHEDULE: 'schedule',
  STAFF_INFO: 'staff-info',
  ADDITIONAL_DOCUMENTS: 'additional-documents',
  AGREEMENT: 'agreement',
};

export const ADD_FACILITY_STEPS_MAPPING = {
  [ADD_FACILITY_STEPS.FACILITY_TYPE]: 0,
  [ADD_FACILITY_STEPS.FACILITY_DETAILS]: 1,
  [ADD_FACILITY_STEPS.BUSINESS_DETAILS]: 2,
  [ADD_FACILITY_STEPS.CREDENTIALS]: 3,
};

export const ADD_SCHOOL_FACILITY_STEPS_MAPPING = {
  [ADD_FACILITY_STEPS.FACILITY_TYPE]: 0,
  [ADD_FACILITY_STEPS.FACILITY_DETAILS]: 1,
  [ADD_FACILITY_STEPS.BUSINESS_DETAILS]: 2,
  [ADD_FACILITY_STEPS.SCHOOL_CREDENTIALS]: 3,
  [ADD_FACILITY_STEPS.CREDENTIALS]: 4,
};

export const ADD_NAVY_HCC_STEPS_MAPPING = {
  [ADD_NAVY_HCC_STEPS.PROGRAM_INFO]: 0,
  [ADD_NAVY_HCC_STEPS.HOURS_OF_OPERATION]: 1,
  [ADD_NAVY_HCC_STEPS.STAFF_MEMBERS]: 2,
  [ADD_NAVY_HCC_STEPS.RESIDENTS]: 3,
  [ADD_NAVY_HCC_STEPS.AGREEMENT]: 4,
};

export const ADD_ARMY_RESPITE_STEPS_MAPPING = {
  [ADD_APPLICATION_STEPS.FAMILY_INFORMATION]: 0,
  [ADD_APPLICATION_STEPS.RATES]: 1,
  [ADD_APPLICATION_STEPS.AGREEMENT]: 2,
};

export const MAP_BRANCH = {
  1: 'USAF',
  2: 'Army',
  3: 'MarineCorps',
  4: 'Navy',
  5: 'NGA',
  6: 'DOD',
  8: 'USSF',
};

export const EMAIL_STATUS = {
  PENDING: 'PENDING',
  QUEUED: 'QUEUED',
  DELIVERED: 'DELIVERED',
  ERROR: 'ERROR',
};

export const ROLES = {
  // Admin Group
  SYSTEM_ADMIN: 'SystemAdmin',

  // Provider Group
  PROVIDER: 'Provider',
  PROVIDER_MANAGER: 'ProviderManager',
  PROVIDER_COORDINATOR: 'ProviderCoordinator',

  PROVIDER_QC_MANAGER: 'ProviderQCManager',
  PROVIDER_QC_COORDINATOR: 'ProviderQCCoordinator',

  PROVIDER_REVIEWER_MANAGER: 'ProviderReviewerManager',
  PROVIDER_REVIEWER: 'ProviderReviewer',

  PROVIDER_BGC_MANAGER: 'ProviderBGCManager',
  PROVIDER_BGC_COORDINATOR: 'ProviderBGCCoordinator',

  PROVIDER_SUPPORT_SPECIALIST: 'ProviderSupportSpecialist',

  // Family Group
  FAMILY: 'Family',
  FAMILY_MANAGER: 'FamilyManager',
  FAMILY_COORDINATOR: 'FamilyCoordinator',

  FAMILY_QC_MANAGER: 'FamilyQCManager',
  FAMILY_QC_COORDINATOR: 'FamilyQCCoordinator',

  FAMILY_SUPPORT_MANAGER: 'FamilySupportManager',
  FAMILY_SUPPORT_SPECIALIST: 'FamilySupportSpecialist',

  ER_MANAGER: 'ERManager',
  ER_COORDINATOR: 'ERCoordinator',

  FINANCE_MANAGER: 'FinanceManager',

  REPORTING_MANAGER: 'ReportingManager',
  REPORTING_ANALYST: 'ReportingAnalyst',

  PAYMENT_MANAGER: 'PaymentManager',
  PAYMENT_COORDINATOR: 'PaymentCoordinator',

  // Parent Services Group
  PARENT_SERVICES_MANAGER: 'ParentServicesManager',
  PARENT_SERVICES_SPECIALIST: 'ParentServicesSpecialist',
};

export const ENTITY_TYPES = {
  FAMILY: 'FamilyApplication',
  HOUSEHOLD: 'FamilyHousehold',
  SPONSOR: 'SponsorPerson',
  PARENT: 'ParentPerson',
  CHILD: 'ChildPerson',
  CARE_FACILITY: 'CareFacility',
  ATTENDANCE_SHEET: 'AttendanceSheet',
  ELIGIBILITY_DATES: 'EligibilityDates',
  EDUCATION: 'Education',
  ATTACHMENT: 'Attachment',
};

export const EMPLOYMENT_STATUS = {
  EMPLOYED: 'Employed',
  UNEMPLOYED: 'Unemployed',
  NONEMPLOYED: 'NonEmployed',
  UNABLE_TO_WORK: 'UnableToWork',
};

export const employmentStatusTypes = [
  {
    id: EMPLOYMENT_STATUS.EMPLOYED,
    description: 'Currently Employed',
  },
  {
    id: EMPLOYMENT_STATUS.UNEMPLOYED,
    description: 'Not Employed - Looking for Work',
  },
  {
    id: EMPLOYMENT_STATUS.NONEMPLOYED,
    description: 'Not Employed',
  },
];

export const commonHead = `
<meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link href="https://fonts.googleapis.com/css?family=Lato:400,400i,700,700i" rel="stylesheet" />
    <link href="https://fonts.googleapis.com/css?family=Lora:400,400i,700,700i" rel="stylesheet" />
    <style>
      .heading {
        margin:0;
        font-family:lora, georgia, serif;font-size:50px;
        font-style:normal;
        font-weight:normal;
        color:#333333;
      }
      .email-phone {
        margin:0;
        font-family:lato, 'helvetica neue', helvetica, arial, sans-serif;
        line-height:21px;
        color:#ffffff;
        font-size:14px;
      }
      .float-container {
        /* padding: 20px; */
        float: none;
      }
      .float-child {
        width: 50%;
        float: left;
        box-sizing: border-box;
        text-align: center;
      }
      .float-child img {
        margin-left: auto;
        margin-right: auto;
      }
      .left {
        border-right: solid 1px #ccc;
      }
      .float-child img.info-icon {
        margin: 0 auto 15px;
      }
      @media only screen and (max-width:600px) {
        .heading {
          font-size:36px;
        }
        .email-phone {
          line-height:18px;
          font-size:12px;
        }
        .float-child {
          float: none;
          width: 100%;
        }
        .float-child p {
          max-width: 300px;
          margin: 5px auto !important;
        }
        .left {
          border-right: none;
          margin-bottom: 20px;
        }
      }
    </style>
`;

export const EMAIL_TYPES = {
  SCHEDULED: 'scheduled',
  SENT: 'sent',
  INCOMING: 'incoming',
};

export const DASHBOARD_TYPES = {
  PROVIDERS: 'Providers',
  FAMILIES: 'Families',
};

export const TYPES_OF_CARE = {
  CHILD_CARE_CENTER: 1,
  SCHOOL: 2,
  FAMILY_CHILD_CARE_HOME: 3,
};

export const EMDASH = '—';
export const ENDASH = '–';
